import * as React from 'react'
import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

interface RouteSpinnerProps {
  className?: string
  label?: string
  showLabel?: boolean
  spinnerClassName?: string
}

export function RouteSpinner({
  className,
  label = 'Carregando...',
  showLabel = false,
  spinnerClassName,
}: RouteSpinnerProps): React.JSX.Element {
  return (
    <div className={cn('flex min-h-[13.75rem] w-full items-center justify-center', className)}>
      <div 
        role="status" 
        aria-live="polite" 
        aria-busy="true"
        className="flex flex-col items-center justify-center gap-3"
      >
        <Spinner className={cn('size-10 text-primary', spinnerClassName)} />
        {showLabel ? (
          <span className="text-xs font-medium text-muted-foreground/80 tracking-wide animate-pulse">
            {label}
          </span>
        ) : (
          <span className="sr-only">{label}</span>
        )}
      </div>
    </div>
  )
}
